import gql from 'graphql-tag';

const getDiscussionId = `
  discussion {
    id
  }
`;

const getRepliesId = `
  replies {
    id
    name
    text
    userId
    createdAt
    attachments
  }
`;

const getChannelId = `
  channel {
    id
  }
`;

const commentInfo = `
  id
  name
  text
  userId
  createdAt
  score
  attachments

  ${getDiscussionId}
  ${getRepliesId}
`;

const discussionInfo = `
  id
  name
  text
  createdAt
  userId
  attachments

  ${getChannelId}
`;

const channelInfo = `
  id
  name
  type
`;

export const channelsByIdQuery = gql`
  query channels($channelIdList: [ID!]) {
    channels(where: { id_in: $channelIdList }) {
      ${channelInfo}
    }
  }
`;

export const channelInfoByIdQuery = gql`
  query channelInfoByIdQuery($channelId: ID!) {
    channel (where: { id: $channelId }) {
      ${channelInfo}

      discussions {
        ${discussionInfo}

        comments {
          ${commentInfo}
        }
      }
    }
  }
`;

export const paginatedChannelInfoByIdQuery = gql`
  query paginatedChannelInfoByIdQuery($channelId: ID!, $first: Int!, $skip: Int!, $orderBy: DiscussionOrderByInput!) {
    discussionsConnection(where: { channel: {id: $channelId }  }, orderBy: $orderBy, first: $first, skip: $skip) {
      edges {
        node {
          ${discussionInfo}

          comments {
            ${commentInfo}
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        pageSize
      }
      aggregate {
        count
      }
    }
  }
`;

export const createDiscussionQuery = gql`
  mutation CreateDiscussionQuery($name: String, $text: String, $userId: Int!, $channelId: ID!, $attachments: [Json!]) {
    createDiscussion(
      data: {
        name: $name
        text: $text
        userId: $userId
        attachments: $attachments
        channel: { connect: { id: $channelId } }
      }
    ) {
      ${discussionInfo}
    }
  }
`;

export const createCommentQuery = gql`
  mutation createComment($text: String!, $discussionId: ID!, $userId: Int!, $attachments: [Json!]) {
    createComment(
      data: {
        text: $text,
        userId: $userId,
        attachments: $attachments,
        discussion: { connect: { id: $discussionId } }
      }
    ) {
      ${commentInfo}
    }
  }
`;

export const createCommentReplyQuery = gql`
  mutation createComment($text: String!, $quotedCommentId: ID!, $userId: Int!, $attachments: [Json!]) {
    createComment(
      data: {
        text: $text,
        userId: $userId,
        attachments: $attachments,
        quotedComment: { connect: { id: $quotedCommentId } }
      }
    ) {
      ${commentInfo}
    }
  }
`;

export const updateCommentScoreById = gql`
  mutation updateCommentScoreById($commentId: ID!, $score: Float) {
    updateComment(data: { score: $score }, where: { id: $commentId }) {
        ${commentInfo}
    }
  }
`;

export const deleteComment = gql`
  mutation deleteComment($commentId: ID!) {
    deleteComment(where: { id: $commentId} ) {
      ${commentInfo}
    }
  }
`;

export const updateComment = gql`
  mutation updateComment($text: String!, $attachments: [Json!], $commentId: ID!) {
    updateComment(data: {
      text: $text
      attachments: $attachments,
    }, where: { id: $commentId } ) {
      ${commentInfo}
    }
  }
`;

export const deleteDiscussion = gql`
  mutation deleteDiscussion($discussionId: ID!) {
    deleteDiscussion(where: { id: $discussionId } ) {
      ${discussionInfo}
    }
  }
`;

export const updateDiscussion = gql`
  mutation updateDiscussion($text: String!, $attachments: [Json!], $discussionId: ID!) {
    updateDiscussion(data: {
      text: $text,
      attachments: $attachments,
    }, where: { id: $discussionId } ) {
      ${discussionInfo}
    }
  }
`;
